// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-62ea636a] .thumbnail-preview-modal{background-color:transparent;box-shadow:none}[data-v-62ea636a] .oimage img{max-width:100%!important}.close[data-v-62ea636a]{position:absolute;z-index:10;cursor:pointer;border-radius:9999px;padding:2rem;--bg-opacity:1;background-color:#f9a91e;background-color:rgba(249,169,30,var(--bg-opacity));top:-2.5rem;right:-2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
